import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import InquiryDate from '../../../component/molecules/InquiryDate';
import { AppState } from '../../../redux/modules/store';


const mapStateToProps = (appState: AppState) => {
  return {
    currentRefresh: appState.currentRefresh,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InquiryDate);
